import React, { createContext, useContext, useState, useEffect } from 'react'

// ─── Translations ─────────────────────────────────────────────────────────────

export const translations = {
  ar: {
    dir: 'rtl',
    appName: 'ضمانتي',

    // Dashboard
    hello: 'أهلاً،',
    active: 'نشط',
    expiringSoon: 'ينتهي قريباً',
    expired: 'منتهي',
    myWarranties: 'ضماناتي',
    loading: 'جاري التحميل...',
    noWarranties: 'لا توجد ضمانات بعد',
    noWarrantiesSub: 'أضف أول ضمان لمنتجاتك بالضغط على الزر أدناه',
    addWarrantyFab: '＋ إضافة ضمان',
    expiresToday: 'ينتهي اليوم',
    daysLeft: (n) => `${n} يوم متبقي`,
    yearsLeft: (y, m) => m === 0 ? `${y} سنة متبقية` : `${y}س ${m}ش متبقي`,
    badgeDays: (n) => `${n} يوم`,

    // AddWarranty
    addWarrantyTitle: 'إضافة ضمان',
    scanTitle: '🧠 مسح ذكي للوصل أو الضمان',
    scanSub: 'صوّر وصلك أو بطاقة الضمان وسيتم تعبئة النموذج تلقائياً',
    camera: 'الكاميرا',
    fromGallery: 'من المعرض',
    orManually: 'أو أدخل يدوياً',
    productName: 'اسم المنتج',
    brand: 'الماركة',
    category: 'الفئة',
    purchaseDate: 'تاريخ الشراء',
    expiryDate: 'تاريخ انتهاء الضمان',
    store: 'المتجر',
    serialNumber: 'الرقم التسلسلي',
    warrantyDoc: 'وثيقة الضمان (PDF)',
    notes: 'ملاحظات',
    saveWarranty: '✔ حفظ الضمان',
    saving: 'جاري الحفظ...',
    uploadingFile: 'جاري رفع الملف...',
    optional: 'اختياري',
    notesPlaceholder: 'أي ملاحظات إضافية...',
    storePlaceholder: 'مثال: jarir, amazon',
    brandPlaceholder: 'مثال: Apple',
    productPlaceholder: 'مثال: iPhone 15 Pro',
    uploadPdfLabel: 'اضغط لرفع ملف PDF',
    uploadPdfSub: 'ملف الضمان أو الفاتورة • حتى 10 ميجابايت',
    changePdf: 'اضغط لتغيير الملف',
    scanAnalyzing: '🧠 جاري تحليل الصورة...',
    scanAutoFill: 'سيتم استخراج البيانات تلقائياً',
    scanExtracted: '✨ تم استخراج البيانات',
    scanReview: 'راجع المعلومات وأكد صحتها',
    confirmFill: '✓ تأكيد وتعبئة النموذج',
    rescan: '🔄 إعادة المسح',
    cancelScan: '✕ إلغاء',
    scanFieldLabels: {
      product_name: 'اسم المنتج',
      brand: 'الماركة',
      category: 'الفئة',
      purchase_date: 'تاريخ الشراء',
      expiry_date: 'تاريخ انتهاء الضمان',
      store: 'المتجر',
      serial_number: 'الرقم التسلسلي',
    },

    // WarrantyDetail
    warrantyDetails: 'تفاصيل الضمان',
    warrantyExpired: 'انتهى الضمان',
    expiresTodayBang: 'ينتهي اليوم!',
    daysLeftDetail: (n) => `يتبقى ${n} يوم`,
    purchaseDateLabel: 'تاريخ الشراء',
    expiryDateLabel: 'تاريخ الانتهاء',
    storeLabel: 'المتجر',
    serialLabel: 'الرقم التسلسلي',
    notesLabel: 'ملاحظات',
    warrantyDocLabel: 'وثيقة الضمان',
    viewPdf: 'عرض ملف PDF',
    deleteWarranty: '🗑 حذف الضمان',
    deleteConfirm: 'هل أنت متأكد من حذف هذا الضمان؟',
    deleteConfirmSub: 'لا يمكن التراجع عن هذا الإجراء.',
    cancel: 'إلغاء',
    warrantyNotFound: 'لم يتم العثور على الضمان',
    editWarranty: 'تعديل الضمان',
    updateWarranty: 'حفظ التعديلات',

    // Profile
    totalWarranties: 'إجمالي الضمانات',
    editName: 'تعديل الاسم',
    changePassword: 'تغيير كلمة المرور',
    darkModeLabel: 'الوضع الداكن',
    lightModeLabel: 'الوضع الفاتح',
    logout: 'تسجيل الخروج',
    fullNameLabel: 'الاسم الكامل',
    saveName: 'حفظ الاسم',
    savingName: 'جاري الحفظ...',
    nameSaved: 'تم تحديث الاسم ✓',
    newPasswordLabel: 'كلمة المرور الجديدة',
    confirmPasswordLabel: 'تأكيد كلمة المرور',
    changePasswordBtn: 'تغيير كلمة المرور',
    changingPassword: 'جاري التغيير...',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح ✓',
    languageLabel: 'اللغة',

    // Login
    welcomeBack: 'مرحباً بعودتك!',
    loginSub: 'سجّل دخولك للوصول إلى ضماناتك',
    emailLabel: 'البريد الإلكتروني',
    passwordLabel: 'كلمة المرور',
    loginBtn: 'تسجيل الدخول',
    loggingIn: 'جاري تسجيل الدخول...',
    forgotPassword: 'نسيت كلمة المرور؟',
    magicLinkBtn: '⚡ دخول سريع برابط على البريد',
    noAccount: 'ليس لديك حساب؟',
    createAccountLink: 'أنشئ حساباً',
    orDivider: 'أو',
    resetTitle: 'إعادة تعيين كلمة المرور',
    resetSub: 'أدخل بريدك وسنرسل لك رابط إعادة التعيين',
    sendReset: 'إرسال رابط إعادة التعيين',
    sending: 'جاري الإرسال...',
    backToLogin: '← العودة لتسجيل الدخول',
    magicTitle: 'الدخول السريع',
    magicSub: 'سنرسل لك رابطاً للدخول الفوري دون كلمة مرور',
    sendMagic: '⚡ إرسال رابط الدخول',

    // Register
    createAccountTitle: 'أنشئ حسابك',
    createAccountSub: 'ابدأ بحفظ ضماناتك مجاناً',
    fullNameInput: 'الاسم الكامل',
    createAccountBtn: 'إنشاء حساب',
    creatingAccount: 'جاري إنشاء الحساب...',
    haveAccount: 'لديك حساب؟',
    signInLink: 'سجّل دخولك',
    accountCreated: 'تم إنشاء حسابك!',
    checkEmail: 'تحقق من بريدك الإلكتروني لتأكيد الحساب ثم سجّل دخولك.',
    signInBtn: 'تسجيل الدخول',

    // Errors
    invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    enterEmailFirst: 'أدخل بريدك الإلكتروني أولاً',
    fillAllFields: 'يرجى ملء جميع الحقول',
    passwordMismatch: 'كلمتا المرور غير متطابقتين',
    passwordTooShort: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    scanFailed: 'تعذّر قراءة الصورة، حاول مرة أخرى',
    pdfOnly: 'يرجى اختيار ملف PDF فقط',
    pdfTooLarge: 'حجم الملف يجب أن يكون أقل من 10 ميجابايت',
    saveError: 'حدث خطأ، حاول مرة أخرى',
    uploadFailed: 'فشل رفع الملف: ',

    // Categories (stored in DB as Arabic)
    categories: [
      { label: 'هواتف', icon: '📱' },
      { label: 'أجهزة كمبيوتر', icon: '💻' },
      { label: 'تلفزيونات', icon: '📺' },
      { label: 'أجهزة منزلية', icon: '🏠' },
      { label: 'سيارات', icon: '🚗' },
      { label: 'ألعاب', icon: '🎮' },
      { label: 'أخرى', icon: '📦' },
    ],

    defaultCategory: 'أخرى',
    userFallback: 'المستخدم',
    greetingFallback: 'مرحباً',

    // Subscription & Pricing
    upgradeToPremium: 'الترقية إلى بريميوم',
    currentPlan: 'خطتك الحالية',
    freePlan: 'مجاني',
    premiumPlan: 'بريميوم',
    premiumBadge: '⭐ بريميوم',
    monthlyPlan: 'شهري',
    yearlyPlan: 'سنوي',
    perMonth: '/ شهر',
    perYear: '/ سنة',
    sarCurrency: 'ر.س',
    subscribe: 'اشترك الآن',
    save50: 'وفّر 50%',
    unlimitedWarranties: 'ضمانات غير محدودة',
    smartScanFeature: 'مسح ذكي للوصولات',
    emailReminders: 'تذكيرات عبر البريد',
    pushNotifications: 'إشعارات قبل انتهاء الضمان',
    docStorage: 'حفظ وثائق الضمان والفواتير',
    warrantyLimitReached: 'وصلت للحد الأقصى',
    warrantyLimitSub: 'الخطة المجانية تسمح بـ 10 ضمانات فقط. قم بالترقية للحصول على ضمانات غير محدودة.',
    upgradeNow: 'ترقية الآن',
    subscriptionLabel: 'الاشتراك',
    expiresOn: 'ينتهي في',
    paymentSuccess: 'تم الدفع بنجاح!',
    youArePremium: 'أنت الآن مشترك في بريميوم',
    redirectingToDashboard: 'جاري التحويل...',
    paymentFailed: 'فشل الدفع',
    paymentFailedSub: 'لم تتم عملية الدفع. يرجى المحاولة مرة أخرى.',
    tryAgain: 'حاول مرة أخرى',
    processingPayment: 'جاري معالجة الدفع...',
    choosePlan: 'اختر خطتك',
    choosePlanSub: 'ابدأ بحفظ جميع ضماناتك بدون حدود',
    whatsIncluded: 'ما الذي ستحصل عليه؟',
    alreadyPremium: 'أنت مشترك بالفعل!',
    manageSubscription: 'إدارة الاشتراك',
    // Free vs Premium comparison
    freeVsPremium: 'المجاني مقابل بريميوم',
    feature: 'الميزة',
    freeCol: 'مجاني',
    premiumCol: 'بريميوم',
    warrantiesLimit: 'عدد الضمانات',
    upTo10: 'حتى 5',
    unlimited: 'غير محدود',
    receiptScan: 'مسح الوصولات',
    basic: 'أساسي',
    advanced: 'متقدم + OCR',
    emailNotif: 'تذكيرات البريد',
    docStorageFeature: 'حفظ الوثائق',
    prioritySupport: 'دعم أولوية',
    // Landing page
    landingHero: 'لا تخسر فلس واحد بسبب ضمان منتهي',
    landingHeroSub: 'ضمانتي يذكرك قبل انتهاء ضمانات منتجاتك حتى لا تفوّت أي مطالبة',
    getStartedFree: 'ابدأ مجاناً',
    alreadyHaveAccount: 'عندك حساب؟ سجّل دخولك',
    howItWorks: 'كيف يعمل؟',
    step1Title: 'أضف ضماناتك',
    step1Sub: 'صوّر الوصل أو أدخل البيانات يدوياً',
    step2Title: 'نحفظها لك',
    step2Sub: 'كل ضماناتك في مكان واحد آمن',
    step3Title: 'نذكّرك قبل الانتهاء',
    step3Sub: 'إشعارات وبريد إلكتروني قبل انتهاء الضمان',
    whyDamanati: 'ليش ضمانتي؟',
    reason1: 'كل ضماناتك في مكان واحد بدل الأوراق والإيميلات',
    reason2: 'تنبيهات ذكية قبل انتهاء الضمان',
    reason3: 'مسح ذكي للوصولات يعبّي النموذج تلقائياً',
    reason4: 'يدعم العربية والإنجليزية',
    startingFrom: 'يبدأ من',
    perMonthShort: '/شهر',
    onlyText: 'فقط',
  },

  en: {
    dir: 'ltr',
    appName: 'Damanati',

    // Dashboard
    hello: 'Hello,',
    active: 'Active',
    expiringSoon: 'Expiring Soon',
    expired: 'Expired',
    myWarranties: 'My Warranties',
    loading: 'Loading...',
    noWarranties: 'No warranties yet',
    noWarrantiesSub: 'Add your first warranty by tapping the button below',
    addWarrantyFab: '＋ Add Warranty',
    expiresToday: 'Expires today',
    daysLeft: (n) => `${n} day${n !== 1 ? 's' : ''} left`,
    yearsLeft: (y, m) => m === 0 ? `${y}y left` : `${y}y ${m}m left`,
    badgeDays: (n) => `${n}d`,

    // AddWarranty
    addWarrantyTitle: 'Add Warranty',
    scanTitle: '🧠 Smart Scan',
    scanSub: 'Photograph your receipt or warranty card to auto-fill the form',
    camera: 'Camera',
    fromGallery: 'Gallery',
    orManually: 'Or enter manually',
    productName: 'Product Name',
    brand: 'Brand',
    category: 'Category',
    purchaseDate: 'Purchase Date',
    expiryDate: 'Warranty Expiry Date',
    store: 'Store',
    serialNumber: 'Serial Number',
    warrantyDoc: 'Warranty Document (PDF)',
    notes: 'Notes',
    saveWarranty: '✔ Save Warranty',
    saving: 'Saving...',
    uploadingFile: 'Uploading file...',
    optional: 'Optional',
    notesPlaceholder: 'Any additional notes...',
    storePlaceholder: 'e.g. Amazon, Best Buy',
    brandPlaceholder: 'e.g. Apple',
    productPlaceholder: 'e.g. iPhone 15 Pro',
    uploadPdfLabel: 'Tap to upload PDF',
    uploadPdfSub: 'Warranty or invoice file • Up to 10MB',
    changePdf: 'Tap to change file',
    scanAnalyzing: '🧠 Analyzing image...',
    scanAutoFill: 'Data will be extracted automatically',
    scanExtracted: '✨ Data Extracted',
    scanReview: 'Review the info and confirm',
    confirmFill: '✓ Confirm & Fill Form',
    rescan: '🔄 Re-scan',
    cancelScan: '✕ Cancel',
    scanFieldLabels: {
      product_name: 'Product Name',
      brand: 'Brand',
      category: 'Category',
      purchase_date: 'Purchase Date',
      expiry_date: 'Warranty Expiry',
      store: 'Store',
      serial_number: 'Serial Number',
    },

    // WarrantyDetail
    warrantyDetails: 'Warranty Details',
    warrantyExpired: 'Warranty Expired',
    expiresTodayBang: 'Expires Today!',
    daysLeftDetail: (n) => `${n} day${n !== 1 ? 's' : ''} left`,
    purchaseDateLabel: 'Purchase Date',
    expiryDateLabel: 'Expiry Date',
    storeLabel: 'Store',
    serialLabel: 'Serial Number',
    notesLabel: 'Notes',
    warrantyDocLabel: 'Warranty Document',
    viewPdf: 'View PDF',
    deleteWarranty: '🗑 Delete Warranty',
    deleteConfirm: 'Are you sure you want to delete this warranty?',
    deleteConfirmSub: 'This action cannot be undone.',
    cancel: 'Cancel',
    warrantyNotFound: 'Warranty not found',
    editWarranty: 'Edit Warranty',
    updateWarranty: 'Save Changes',

    // Profile
    totalWarranties: 'Total Warranties',
    editName: 'Edit Name',
    changePassword: 'Change Password',
    darkModeLabel: 'Dark Mode',
    lightModeLabel: 'Light Mode',
    logout: 'Sign Out',
    fullNameLabel: 'Full Name',
    saveName: 'Save Name',
    savingName: 'Saving...',
    nameSaved: 'Name updated ✓',
    newPasswordLabel: 'New Password',
    confirmPasswordLabel: 'Confirm Password',
    changePasswordBtn: 'Change Password',
    changingPassword: 'Changing...',
    passwordChanged: 'Password changed successfully ✓',
    languageLabel: 'Language',

    // Login
    welcomeBack: 'Welcome back!',
    loginSub: 'Sign in to access your warranties',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    loginBtn: 'Sign In',
    loggingIn: 'Signing in...',
    forgotPassword: 'Forgot password?',
    magicLinkBtn: '⚡ Quick login with email link',
    noAccount: "Don't have an account?",
    createAccountLink: 'Create an account',
    orDivider: 'or',
    resetTitle: 'Reset Password',
    resetSub: "Enter your email and we'll send you a reset link",
    sendReset: 'Send Reset Link',
    sending: 'Sending...',
    backToLogin: '← Back to Sign In',
    magicTitle: 'Quick Login',
    magicSub: "We'll send you an instant login link, no password needed",
    sendMagic: '⚡ Send Login Link',

    // Register
    createAccountTitle: 'Create your account',
    createAccountSub: 'Start saving your warranties for free',
    fullNameInput: 'Full Name',
    createAccountBtn: 'Create Account',
    creatingAccount: 'Creating account...',
    haveAccount: 'Already have an account?',
    signInLink: 'Sign in',
    accountCreated: 'Account created!',
    checkEmail: 'Check your email to confirm your account then sign in.',
    signInBtn: 'Sign In',

    // Errors
    invalidCredentials: 'Invalid email or password',
    enterEmailFirst: 'Please enter your email first',
    fillAllFields: 'Please fill in all fields',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    scanFailed: 'Could not read image, please try again',
    pdfOnly: 'Please select a PDF file only',
    pdfTooLarge: 'File size must be less than 10MB',
    saveError: 'An error occurred, please try again',
    uploadFailed: 'Upload failed: ',

    // Categories (DB stores Arabic — map for display)
    categories: [
      { label: 'Phones', icon: '📱' },
      { label: 'Computers', icon: '💻' },
      { label: 'TVs', icon: '📺' },
      { label: 'Home Appliances', icon: '🏠' },
      { label: 'Cars', icon: '🚗' },
      { label: 'Gaming', icon: '🎮' },
      { label: 'Other', icon: '📦' },
    ],

    defaultCategory: 'Other',
    userFallback: 'User',
    greetingFallback: 'Hello',

    // Subscription & Pricing
    upgradeToPremium: 'Upgrade to Premium',
    currentPlan: 'Current Plan',
    freePlan: 'Free',
    premiumPlan: 'Premium',
    premiumBadge: '⭐ Premium',
    monthlyPlan: 'Monthly',
    yearlyPlan: 'Yearly',
    perMonth: '/ month',
    perYear: '/ year',
    sarCurrency: 'SAR',
    subscribe: 'Subscribe Now',
    save50: 'Save 50%',
    unlimitedWarranties: 'Unlimited warranties',
    smartScanFeature: 'Smart receipt scanning',
    emailReminders: 'Email expiry reminders',
    pushNotifications: 'Push notifications before expiry',
    docStorage: 'Warranty document & receipt storage',
    warrantyLimitReached: 'Warranty limit reached',
    warrantyLimitSub: 'The free plan allows only 10 warranties. Upgrade for unlimited warranties.',
    upgradeNow: 'Upgrade Now',
    subscriptionLabel: 'Subscription',
    expiresOn: 'Expires on',
    paymentSuccess: 'Payment successful!',
    youArePremium: 'You are now a Premium member',
    redirectingToDashboard: 'Redirecting...',
    paymentFailed: 'Payment failed',
    paymentFailedSub: 'The payment was not completed. Please try again.',
    tryAgain: 'Try Again',
    processingPayment: 'Processing payment...',
    choosePlan: 'Choose your plan',
    choosePlanSub: 'Save all your warranties with no limits',
    whatsIncluded: "What's included?",
    alreadyPremium: 'You are already subscribed!',
    manageSubscription: 'Manage Subscription',
    // Free vs Premium comparison
    freeVsPremium: 'Free vs Premium',
    feature: 'Feature',
    freeCol: 'Free',
    premiumCol: 'Premium',
    warrantiesLimit: 'Warranties',
    upTo10: 'Up to 5',
    unlimited: 'Unlimited',
    receiptScan: 'Receipt scanning',
    basic: 'Basic',
    advanced: 'Advanced + OCR',
    emailNotif: 'Email reminders',
    docStorageFeature: 'Document storage',
    prioritySupport: 'Priority support',
    // Landing page
    landingHero: 'Never lose money on an expired warranty again',
    landingHeroSub: 'Damanati reminds you before your warranties expire so you never miss a claim',
    getStartedFree: 'Get Started Free',
    alreadyHaveAccount: 'Already have an account? Sign in',
    howItWorks: 'How it works',
    step1Title: 'Add your warranties',
    step1Sub: 'Scan your receipt or enter details manually',
    step2Title: 'We keep them safe',
    step2Sub: 'All your warranties in one secure place',
    step3Title: 'Get reminded before expiry',
    step3Sub: 'Push notifications and emails before warranty ends',
    whyDamanati: 'Why Damanati?',
    reason1: 'All your warranties in one place instead of scattered receipts',
    reason2: 'Smart alerts before warranty expiry',
    reason3: 'AI-powered receipt scanning auto-fills the form',
    reason4: 'Full Arabic and English support',
    startingFrom: 'Starting from',
    perMonthShort: '/mo',
    onlyText: 'only',
  },
}

// Arabic → English category name map (DB stores Arabic)
export const categoryTranslation = {
  'هواتف': 'Phones',
  'أجهزة كمبيوتر': 'Computers',
  'تلفزيونات': 'TVs',
  'أجهزة منزلية': 'Home Appliances',
  'سيارات': 'Cars',
  'ألعاب': 'Gaming',
  'أخرى': 'Other',
}

// Icon map covering both Arabic and English keys
export const categoryIcons = {
  'هواتف': '📱', 'Phones': '📱',
  'أجهزة كمبيوتر': '💻', 'Computers': '💻',
  'تلفزيونات': '📺', 'TVs': '📺',
  'أجهزة منزلية': '🏠', 'Home Appliances': '🏠',
  'سيارات': '🚗', 'Cars': '🚗',
  'ألعاب': '🎮', 'Gaming': '🎮',
  'أخرى': '📦', 'Other': '📦',
}

// ─── Context ──────────────────────────────────────────────────────────────────

const LanguageContext = createContext(null)

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'ar')

  const t = translations[lang]

  useEffect(() => {
    localStorage.setItem('lang', lang)
    document.documentElement.dir = t.dir
    document.documentElement.lang = lang
    document.body.classList.toggle('lang-en', lang === 'en')
  }, [lang, t.dir])

  const toggleLang = () => setLang(l => l === 'ar' ? 'en' : 'ar')

  // Translate a category stored in DB (always Arabic) to current language
  const translateCategory = (arCategory) => {
    if (lang === 'ar') return arCategory
    return categoryTranslation[arCategory] || arCategory
  }

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang, translateCategory }}>
      {children}
    </LanguageContext.Provider>
  )
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useLanguage() {
  const ctx = useContext(LanguageContext)
  if (!ctx) throw new Error('useLanguage must be used inside <LanguageProvider>')
  return ctx
}

// ─── Toggle Button Component ──────────────────────────────────────────────────

export function LangToggle() {
  const { lang, toggleLang } = useLanguage()
  return (
    <button className="lang-toggle" onClick={toggleLang} title="Switch language">
      {lang === 'ar' ? 'EN' : 'ع'}
    </button>
  )
}
